import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { 
    setCompanyModalOpen,
    get_company_list,
    get_payment_terms_list,
    create_company,
    update_company,
    setAction,
    setId,
    setStatus,        
    setSearchQuery,
    setCompanyPage,
    activate_deactivate_company,
    assign_process_company,
    get_company_details 
 } from "../../../store/company/companySlice";
 import { get_process_list } from "../../../store/process/processSlice";
 import { get_company_process } from "../../../store/user/userSlice";

 const mapStateToProps = (state) => {
    const {
        is_company_modal_open,
        company_list,
        common_loading,
        page,
        c_action,
        company_id,
        selected_status,
        search_query,
        selected_data, 
        total_company_count,
        active_company, 
        assign_process,              
    } = state.company;
    const {process_list} = state.process;
    const {company_process} = state.user;

    return {
      total_company_count : total_company_count,
      active_company : active_company,
      is_company_modal_open : is_company_modal_open,
      company_list : company_list,
      assign_process : assign_process,
      common_loading : common_loading,
      page : page,
      c_action : c_action,
      company_id : company_id,
      selected_status : selected_status, 
      selected_data : selected_data,  
      search_query : search_query,   
      process_list: process_list,
      company_process:company_process
    };
  };
  
  
  const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
      setCompanyModalOpen,
      get_company_list,
      get_payment_terms_list,
      create_company,
      update_company,
      activate_deactivate_company,
      assign_process_company,
      get_company_details,
      setSearchQuery,
      setCompanyPage,
      setAction,
      setId,
      setStatus, 
      get_process_list,
      get_company_process
    }, dispatch);
    
  
  const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);
  
  export default Store;